import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@nerdwallet/currency';

import { useABTest } from '@nerdwallet/features';

import classes from '@nerdwallet/base-styles/classes';
import { trackImpression } from '../../lib/analytics-helpers';
import { openAuthDialog } from '../../lib/helpers';

const HomePageReg = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [showHomePageReg, setShowHomePageReg] = useState(true);
  const screenRef = useRef();

  const trkLocation = 'hp_reg';
  const dashboardUrl = '/home/dashboard/home';

  const { variantName, loading, ref } = useABTest({
    testName: 'registration_landing_modal',
  });

  useEffect(() => {
    if (loading) return;

    const isLoggedIn =
      // eslint-disable-next-line no-underscore-dangle
      window?.__GLOBAL_MARKUP_INITIAL_STATE__?.isLoggedIn;

    const openRegisterAuthDialogHelper = () => {
      openAuthDialog({
        authType: 'register',
        trkLocation,
        variantName,
        onCleanUp: () => {
          setIsUserLoggedIn(true);
          setShowHomePageReg(false);
        },
      });
    };

    const authEmbedProps = {
      el: screenRef.current,
      authType: 'register',
      flowConfig: {
        isWelcomeRegModal: true,
        enableSuccessErrorModals: false,
        isHomePageReg: true,
        openRegisterAuthDialog: openRegisterAuthDialogHelper,
      },
      version: 2,
      flow: 'no-security-question',
      trk: {
        trk_location: trkLocation,
      },
      onSuccess() {
        trackImpression('hp_reg_success');
        setIsUserLoggedIn(true);
      },
      onFailure() {
        trackImpression('hp_reg_failure');
      },
    };

    if (!isLoggedIn) {
      authEmbedProps.onSuccess = dashboardUrl;
    }

    window.nwapi?.ui?.showAuthEmbed(authEmbedProps);
  }, [variantName, loading]);

  const renderHomePageReg = () => {
    if (!showHomePageReg) {
      return null;
    }

    return <div ref={screenRef} />;
  };

  const renderMyNerdwalletButton = () => {
    if (!isUserLoggedIn) {
      return null;
    }

    return (
      <div className={classes('margin-vertical-3')}>
        <Button secondary block href={dashboardUrl}>
          Go to My NerdWallet
        </Button>
      </div>
    );
  };

  return (
    <div ref={ref}>
      {renderHomePageReg()}
      {renderMyNerdwalletButton()}
    </div>
  );
};

export default HomePageReg;
